import React from 'react'
import { ActionButtonsProps } from './ActionButtons.types'
import { Box, useTheme } from '@mui/system'
import { Button } from '@mui/material'


const ActionButtons = ({ onCreate,
    onDeleteSelected,
    onCopySelected,
    createLabel = 'Dodaj',
    deleteLabel = 'Kasuj zaznaczone',
    copyLabel = 'Kopiuj zaznaczoną',
    isCopyDisabled = false,
    sx, }: ActionButtonsProps) => {
    const theme = useTheme()
    return (
        <Box sx={{ display: 'flex', gap: 2, mb: 2, ...sx }}>
            {onCreate && <Button variant="contained" sx={{ backgroundColor: theme.palette.primary.main }} onClick={onCreate}>
                {createLabel}
            </Button>}
            {onDeleteSelected && <Button variant="contained" sx={{ backgroundColor: theme.palette.warning.main }} onClick={onDeleteSelected}>
                {deleteLabel}
            </Button>}
            {onCopySelected && <Button variant="contained" sx={{ backgroundColor: theme.palette.info.main }} onClick={onCopySelected} disabled={isCopyDisabled}>
                {copyLabel}
            </Button>}
        </Box>
    )
}

export default ActionButtons